export interface ChallengePriority {
  priority: number;
  description: string;
}

export interface ProductionDifficulties {
  [key: string]: number | ChallengePriority[] | undefined;
  others?: ChallengePriority[];
}

// Mapeamento das chaves da API para os valores de exibição
export const challengeMap: Record<string, string> = {
  road_conditions: 'Condições das vias de acesso',
  need_bridge_construction_special_works: 'Necessidade de construção de pontes/obras especiais',
  difficulty_accessing_localities: 'Dificuldade de acesso às localidades',
  distance_consumer_centers: 'Distância dos centros consumidores',
  lack_consumer_market: 'Falta de mercado consumidor',
  difficulty_accessing_rural_credit: 'Dificuldade de acesso ao crédito rural',
  health_conditions_family_members: 'Condições de saúde dos membros da família',
  lack_vehicles_transport_production: 'Falta de veículos para transporte da produção',
  lack_appropriate_vehicle_perishables: 'Falta de veículo adequado para perecíveis',
  lack_labor: 'Falta de mão de obra',
  high_production_cost: 'Alto custo de produção',
  lack_information: 'Falta de informação',
  environmental_regularization: 'Regularização ambiental',
  fiscal_regularization: 'Regularização fiscal',
  land_regularization: 'Regularização fundiária',
  sanitary_regularization: 'Regularização sanitária'
};

export function processChallenges(data: ProductionDifficulties | null) {
  if (!data) return [] as { value: string; priority: number }[];

  const desafios: { value: string; priority: number }[] = [];

  Object.entries(data).forEach(([key, value]) => {
    if (key !== 'others' && typeof value === 'number' && value > 0 && challengeMap[key]) {
      desafios.push({ value: challengeMap[key], priority: value });
    }
  });

  if (data.others && Array.isArray(data.others)) {
    data.others.forEach(other => {
      desafios.push({ value: other.description, priority: other.priority });
    });
  }

  return desafios.sort((a, b) => a.priority - b.priority);
}

export function hasStandardChallenges(data: ProductionDifficulties | null) {
  if (!data) return false;
  return Object.entries(data).some(([key, value]) => key !== 'others' && typeof value === 'number' && value > 0);
}

export function hasCustomChallenges(data: ProductionDifficulties | null) {
  return !!(data && data.others && data.others.length > 0);
}
